(() => {
	// Batida Connect switch (snippets/batida-connect-switch.liquid): when on, the same requests go to Batida Connect
	// (identical request/response shapes); otherwise to Zapiet as before.
	const ZBC = window.BatidaConnect && window.BatidaConnect.active;
	const ZBASE = ZBC ? window.BatidaConnect.api + 'v1.0/' : 'https://api.zapiet.com/v1.0/';
	const ZQS = ZBC ? '' : `?shop=${(window.Shopify && window.Shopify.shop) || ''}`;
	const zapietAvailabilityRoot = document.querySelector('#zapiet-availability');

	if (!zapietAvailabilityRoot) return;

	const productId = zapietAvailabilityRoot.dataset.productId;
	const variantId = zapietAvailabilityRoot.dataset.variantId;
	const shippingEnabled =
		zapietAvailabilityRoot.dataset.shippingEnabled === 'true';
	const tags = zapietAvailabilityRoot.dataset.tags
		? zapietAvailabilityRoot.dataset.tags.split(',').map((tag) => tag.trim())
		: [];

	const COMMON_FETCH_SETTINGS = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json'
		}
	};

	const WARSAW_ZIP = '00-002';
	const DEFAULT_ZIP = '00-001';

	const shoppingCartPayload = {
		shoppingCart: [
			{
				product_id: parseInt(productId, 10),
				variant_id: parseInt(variantId, 10),
				quantity: 1,
				tags
			}
		]
	};

	const hasFetchBody = productId && variantId;

	// Helper functions
	const formatDate = (dateString) => {
		const [year, month, day] = dateString.split('-');
		return `${day}.${month}`;
	};

	const dateFromString = (dateString) => {
		const [year, month, day] = dateString.split('-');
		return new Date(year, month - 1, day);
	};

	const stringFromDate = (date) => {
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		return `${year}-${month}-${day}`;
	};

	const dateStrFromArr = (dateArray) => {
		const year = dateArray[0];
		const month = String(dateArray[1] + 1).padStart(2, '0');
		const day = String(dateArray[2]).padStart(2, '0');
		return `${year}-${month}-${day}`;
	};

	const updateElementText = (el, text) => {
		if (el) {
			el.innerHTML = text;
		}
	};

	const displayError = (el) => {
		if (el?.dataset.zapietErrorMessage) {
			updateElementText(el, el.dataset.zapietErrorMessage);
		}
	};

	const fetchZapietData = async (url, body) => {
		const response = await fetch(url, {
			...COMMON_FETCH_SETTINGS,
			body: JSON.stringify(body)
		});
		if (!response.ok) {
			throw new Error(`Request failed: ${response.statusText}`);
		}
		const data = await response.json();
		return data;
	};

	const getMinDate = async (url, fetchSettings, excludeWeekends = false) => {
		const dateData = await fetchZapietData(url, fetchSettings);

		// 8.10 (audit JS-01): a product with no dates (minDate null) made dateFromString() throw "Cannot read properties of null
		// (reading 'split')". Same outcome as before - the callers' catch shows the "no date" text - but with a plain error. Revert: delete these 3 lines.
		if (!dateData || !dateData.minDate) {
			throw new Error('no dates');
		}

		const isWhitelist = dateData.disabled[0] === true;
		const disabledWeekdays = new Set();
		const specificDates = new Set();

		dateData.disabled.forEach((entry) => {
			if (Array.isArray(entry)) {
				const time = dateFromString(dateStrFromArr(entry)).getTime();
				if (!isNaN(time)) specificDates.add(time);
			} else if (typeof entry === 'number') {
				disabledWeekdays.add(entry);
			}
		});

		if (excludeWeekends) {
			disabledWeekdays.add(1); // Sunday (getDay()=0, +1=1)
			disabledWeekdays.add(7); // Saturday (getDay()=6, +1=7)
		}

		const minDate = dateFromString(dateData.minDate);
		let loops = 0;

		while (loops < 365) {
			const time = minDate.getTime();
			const day = minDate.getDay() + 1;

			const isDayDisabled = disabledWeekdays.has(day);
			const isDateSpecific = specificDates.has(time);

			const shouldSkip = isWhitelist 
				? (!isDateSpecific || isDayDisabled) 
				: (isDateSpecific || isDayDisabled);

			if (!shouldSkip) break;

			minDate.setDate(minDate.getDate() + 1);
			loops++;
		}
		
		return stringFromDate(minDate);
	};

	// Only the newest calendar answer is shown (A-03). Declared BEFORE the first render: a `let` below it was still in its
	// temporal dead zone when renderPickup ran on load, so the first dates never appeared (spinner, 30.09).
	var pickupSeq = 0, deliverySeq = 0;
	const cookieZipCode = getCookie('zip_cookie');
	renderPickup(cookieZipCode || DEFAULT_ZIP);
	renderDelivery(WARSAW_ZIP);
	renderShipping();

	// Lead time per size (29.09, Batida Connect "czas realizacji per wariant"): when the dates come from Batida Connect
	// and this product has a size with its own lead time (data-variant-hours, set by snippets/batida-pickup-hero.liquid
	// only when a variant has custom.czas_realizacji_h), the boutique and delivery dates follow the chosen size: the
	// calendars are asked again with the new variant id. DPD (whole days) does not depend on the size. With Zapiet, or
	// without such values, nothing here runs.
	// 30.09 (audit A-03): the product's OWN form is the one outside the upsell/cross-sell blocks - the page has several
	// add-to-cart forms and the first belongs to an upsell product, so the size change was never seen. The badges on the
	// photo ("24H", "Zamów na jutro") and the "Zamów na jutro" chip follow the chosen size too (data-variant-hours =
	// {"<variant id>": hours}; a size over 24 h shows its own hours and no "tomorrow").
	if (ZBC && zapietAvailabilityRoot.dataset.variantHours) {
		let lastVariant = String(variantId || '');
		let hoursMap = {};
		try { hoursMap = JSON.parse(zapietAvailabilityRoot.dataset.variantHours) || {}; } catch (e) { hoursMap = {}; }
		const productInput = () => Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]'))
			.filter((i) => !i.closest('.product__block__upsell, [class*="upsell"], .cross-products, .v7-card'))[0];
		const badges = () => {
			const h = Number(hoursMap[lastVariant]) || 0, long = h > 24;
			const ink = document.querySelector('.v7-badge--ink'), pink = document.querySelector('.v7-badge--pink');
			if (ink) { if (ink.dataset.orig == null) ink.dataset.orig = ink.textContent; ink.textContent = long ? h + 'H' : ink.dataset.orig; }
			const tomorrow = pink ? (pink.dataset.orig != null ? pink.dataset.orig : pink.textContent).trim() : '';
			if (pink) { if (pink.dataset.orig == null) pink.dataset.orig = pink.textContent; pink.hidden = long; }
			if (tomorrow) Array.prototype.forEach.call(document.querySelectorAll('.v7-chip'), (c) => { if (c.textContent.trim() === tomorrow) c.hidden = long; });
			// 6.10 (audit UX-01): the "order by 21:00, get it the next day" sentence is only true for a 24 h size.
			Array.prototype.forEach.call(document.querySelectorAll('.v7-nextday-note'), (n) => { n.hidden = long; });
		};
		// A size change must not leave the previous size's dates on screen while the calendars are asked again
		// (or when the answer is "unavailable"): back to the spinner first.
		const resetDates = () => {
			Array.prototype.forEach.call(zapietAvailabilityRoot.querySelectorAll('[data-zapiet-pickup], [data-zapiet-delivery]'), (el) => {
				el.innerHTML = '<span class="bph-loader"></span>';
			});
		};
		badges();
		const refresh = () => {
			const input = productInput();
			const v = input && String(input.value || '');
			if (!v || v === lastVariant) return;
			lastVariant = v;
			badges();
			shoppingCartPayload.shoppingCart[0].variant_id = parseInt(v, 10);
			resetDates();
			renderPickup(getCookie('zip_cookie') || DEFAULT_ZIP);
			renderDelivery(WARSAW_ZIP);
		};
		const soon = () => { setTimeout(refresh, 80); setTimeout(refresh, 400); setTimeout(refresh, 1200); };
		document.addEventListener('change', soon, true);
		document.addEventListener('click', (e) => {
			if (e.target.closest && e.target.closest('.selector-wrapper, .batida-size-card, [data-popout-option], .batida-cake-configurator')) soon();
		}, true);
	}

	async function renderPickup(geoSearchQuery) {
		const pickupEL = zapietAvailabilityRoot.querySelector(
			'[data-zapiet-pickup]'
		);
		if (!pickupEL) return;
		const seq = ++pickupSeq;

		try {
			const locationsData = await fetchZapietData(
				`${ZBASE}pickup/locations${ZQS}`,
				{ geoSearchQuery, ...shoppingCartPayload }
			);

			// 1.10 (Sol audit J-03): "Najbliższy odbiór" = the earliest day at ANY pickup point, not the first point in
			// the list (showed 03.10 while Giełdowa had 02.10). All points in parallel; a failing point is skipped.
			const ids = (locationsData.locations || []).map((l) => l.id);
			if (!ids.length) throw new Error('no pickup locations');
			const dates = await Promise.all(ids.map((id) => getMinDate(
				`${ZBASE}pickup/locations/${id}/calendar${ZQS}`,
				hasFetchBody ? shoppingCartPayload : {}
			).catch(() => null)));
			const dateStr = dates.filter(Boolean).sort()[0];
			if (!dateStr) throw new Error('no pickup dates');

			if (seq !== pickupSeq) return;
			updateElementText(pickupEL, formatDate(dateStr));
		} catch (error) {
			if (seq !== pickupSeq) return;
			displayError(pickupEL);
			console.error('Error fetching Zapiet pickup availability:', error);
		}
	}

	async function renderDelivery(geoSearchQuery) {
		const deliveryEL = zapietAvailabilityRoot.querySelector(
			'[data-zapiet-delivery]'
		);
		if (!deliveryEL) return;
		const seq = ++deliverySeq;

		try {
			const locationsData = await fetchZapietData(
				`${ZBASE}delivery/locations${ZQS}`,
				{ geoSearchQuery, ...shoppingCartPayload }
			);

			if (locationsData.error) {
				throw new Error(locationsData.error.message);
			}

			const dateStr = await getMinDate(
				`${ZBASE}delivery/locations/${locationsData.id}/calendar${ZQS}`,
				hasFetchBody ? shoppingCartPayload : {}
			);

			if (seq !== deliverySeq) return;
			updateElementText(deliveryEL, formatDate(dateStr));
		} catch (error) {
			if (seq !== deliverySeq) return;
			displayError(deliveryEL);
			console.error('Error fetching Zapiet delivery availability:', error);
		}
	}

	async function renderShipping() {
		const shippingEL = zapietAvailabilityRoot.querySelector(
			'[data-zapiet-shipping]'
		);
		if (!shippingEL) return;

		if (!shippingEnabled) {
			displayError(shippingEL);
			return;
		}

		try {
			const dateStr = await getMinDate(
				`${ZBASE}shipping/calendar${ZQS}`,
				hasFetchBody ? shoppingCartPayload : {},
				true
			);

			updateElementText(shippingEL, formatDate(dateStr));
		} catch (error) {
			displayError(shippingEL);
			console.error('Error fetching Zapiet shipping availability:', error);
		}
	}
})();
